const steps = [
    {
        selector: '[data-tour="step-1"]',
        content: 'First time here? Let\'s have a look around!'
    },
    {
        selector: '[data-tour="step-2"]',
        content: 'Get started by adding a new goal.'
    },
    {
        selector: '[data-tour="step-3"]',
        content: 'You can keep tabs on all of your goals here.'
    },
    {
        selector: '[data-tour="step-4"]',
        content: 'Your habits are the actions you\'ll take to help you achieve your goal.'
    },
    {
        selector: '[data-tour="step-5"]',
        content: 'Don\'t forget to sign in and check them off each day!'
    },
    {
        selector: '[data-tour="step-6"]',
        content: 'This nifty chart will track your progress. More detailed stats can be found on the analytics page.'
    },
    {
        selector: '[data-tour="step-7]',
        content: 'Now you\'re ready to get started. Habby tracking!'
    }
];
  
export default steps;
  
